// Claim lists (backend routes/claim_lists.py): a saved, linkable set of a practice's
// claims with notes. Every call checks response.ok and throws the server's message, so
// each caller can show it.

const API_URL = process.env.REACT_APP_API_URL || "";

async function call(url, options = {}) {
  const response = await fetch(`${API_URL}${url}`, {
    credentials: "include",
    ...options,
    headers: options.body
      ? { "Content-Type": "application/json", ...(options.headers || {}) }
      : options.headers,
  });
  let data = {};
  try {
    data = await response.json();
  } catch (err) {
    data = {};
  }
  if (!response.ok) {
    const error = new Error(data.error || "The request did not complete.");
    error.status = response.status;
    throw error;
  }
  return data;
}

const base = (practiceId) => `/api/practices/${practiceId}/claim-lists`;

export function fetchClaimLists(practiceId) {
  return call(base(practiceId)).then((d) => d.lists || []);
}

export function fetchClaimList(practiceId, listId) {
  return call(`${base(practiceId)}/${listId}?per_page=1`).then((d) => d.list);
}

export function createClaimList(practiceId, { title, claimIds, notes, source }) {
  const body = { title, claim_ids: claimIds };
  if (notes) body.notes = notes;
  if (source) body.source = source;
  return call(base(practiceId), {
    method: "POST",
    body: JSON.stringify(body),
  }).then((d) => d.list);
}

export function updateClaimList(practiceId, listId, changes) {
  return call(`${base(practiceId)}/${listId}`, {
    method: "PATCH",
    body: JSON.stringify(changes),
  }).then((d) => d.list);
}

export function listPath(practiceId, listId) {
  return `/p/${practiceId}/lists/${listId}`;
}

export function listUrl(practiceId, listId) {
  return `${window.location.origin}${listPath(practiceId, listId)}`;
}
